import * as url from "../url.helper";

import { post } from "../api.helper";

export const addApiConfiguration = data => post(url.ADD_API_CONFIGURATION, data);

export const getApiConfiguration = data => post(url.GET_API_CONFIGURATION, data);

export const editApiConfiguration = data => post(url.EDIT_API_CONFIGURATION, data);

export const getOneApiConfiguration = data => post(url.GET_ONE_API_CONFIGURATION, data);